import { Search } from "@mui/icons-material";
import { Box, IconButton, Stack } from "@mui/material/index";
import { CBAuth } from "../types";
import { useHasScope } from "../../../config/globalConfig";
import { useTranslation } from "react-i18next";
import { SyntheticEvent } from "react";
import CBAccordionTitle from "./CBAccordionTitle";

interface CBIntegrationSearchProps {
    isPerson: boolean,
    handleSearchClick: (e: SyntheticEvent) => void
}
const CBIntegrationSearch = ({
    isPerson,
    handleSearchClick
    
}: CBIntegrationSearchProps) => {

    const hasScope = useHasScope;
    const { t } = useTranslation(['customerbase']);

    return (
        <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} width={"100%"}>
            <CBAccordionTitle
                section="cbPersonalOrganizationInfo"
                label={isPerson ? t("tabs.accordionsLabels.cbPersonalDetails") : t("tabs.accordionsLabels.cbOrganizationInfo")}
            />
            {(hasScope(CBAuth.SCOPE_CREATE_PERSON_CUSTOMER) || hasScope(CBAuth.SCOPE_CREATE_ORGANIZATION_CUSTOMER)) && 
                <IconButton sx={{mr: 2}} onClick={handleSearchClick}>
                    <Search fontSize="small"/>
                </IconButton>
            }
        </Stack>
    )

}

export default CBIntegrationSearch;